import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentDialogVisibilityBannerIcon from './VeltCommentDialogVisibilityBannerIcon/VeltCommentDialogVisibilityBannerIcon';
import VeltCommentDialogVisibilityBannerText from './VeltCommentDialogVisibilityBannerText/VeltCommentDialogVisibilityBannerText';
import VeltCommentDialogVisibilityBannerDropdown from './VeltCommentDialogVisibilityBannerDropdown/VeltCommentDialogVisibilityBannerDropdown';
import { transformWireframeProps } from '../../../utils/propUtils';
;
var VeltCommentDialogVisibilityBanner = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-visibility-banner-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogVisibilityBanner.Icon = VeltCommentDialogVisibilityBannerIcon;
VeltCommentDialogVisibilityBanner.Text = VeltCommentDialogVisibilityBannerText;
VeltCommentDialogVisibilityBanner.Dropdown = VeltCommentDialogVisibilityBannerDropdown;
export default VeltCommentDialogVisibilityBanner;
